import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatNotification = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.48 0) scale(0.96)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8 14.5H16M8 10.5H12M21.9664 11.7166C21.9886 11.9748 22 12.2361 22 12.5C22 17.4706 17.9706 21.5 13 21.5H6C3.79086 21.5 2 19.7091 2 17.5V12.5C2 7.52944 6.02944 3.5 11 3.5H13C13.2639 3.5 13.5252 3.51136 13.7834 3.53362M22 6.5C22 8.15685 20.6569 9.5 19 9.5C17.3431 9.5 16 8.15685 16 6.5C16 4.84315 17.3431 3.5 19 3.5C20.6569 3.5 22 4.84315 22 6.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 6.5,
			r: 3,
			fill: "none",
			stroke: "none",
			strokeWidth: 1.5
		})]
	})]
});
const ForwardRef = forwardRef(SvgChatNotification);
export default ForwardRef;
